import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { LocalStorageProvider } from '../providers/storage/local-storage.provider';
export const loginGuardProvider: CanActivateFn = async (route, state) => {
  const router = inject(Router);
  const coockieService = inject(LocalStorageProvider);
  coockieService.getAccessToken().subscribe({
    next: (r: any) => {
      if (r) {
        router.navigate(['admin/home']);
      }
    }
  });

  return true;
};
